import { createLogger as _createLogger } from 'redux-logger';

export const createLogger = (shouldLog: boolean) => {
    return _createLogger({
        collapsed: true,
        predicate: shouldLog ? null : false,
    });
};
